import React, { useEffect } from 'react'
import { useHistory } from 'react-router'

import { AcornsIcon } from '@acorns/icons'
import {
  ActionStrip,
  Bodytext,
  Button,
  Card,
  Heading,
  WebViewActionStrip,
} from '@acorns/web-components'
import { useAnalyticsClient } from '@acorns/web-utils'
import styled from 'styled-components'

import LeavesFalling from 'assets/images/leavesFalling.png'
import FullscreenTakeover from 'components/FullscreenTakeover'
import useWindowDimensions from 'hooks/useWindowDimensions'
import { style } from 'theme'

import { UpgradeSubscriptionDone, UpgradeSubscriptionDoneCTA } from './segment'

type Props = {
  isWebView: boolean
  handleBackPress: () => void
  handleDirectToPresent: () => void
}

const ButtonContainer = styled.div`
  padding: 20px 20px 75px 20px;
  width: 100%;
`
const StyledButton = styled(Button)`
  margin: 0 auto;
  width: 240px;
  margin-top: 50px;
  @media (max-width: ${style((theme) => theme.breakpoints.sm - 1)}px) {
    width: 100%;
    margin-top: 0;
  }
`

const StyledCard = styled(Card)<{ innerHeight?: number }>`
  overflow: scroll;
  background-image: url('${LeavesFalling}');
  background-repeat: repeat-x;
  background-size: 500px 285px;
  background-position: 40px -70%;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  max-width: 800px;
  width: 100%;
  height: 412px;
  margin: 0 auto;
  text-align: center;

  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    background-position: top;
    max-width: 100%;
    margin-top: 0;
    height: ${(props) => `calc(${props.innerHeight}px - 78px)`};
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: center;
    border-radius: 0 !important;
  }
`

const WVCard = styled(StyledCard)<{ innerHeight?: number }>`
  &&& {
    height: ${(props) => `calc(${props.innerHeight}px - 80px)`};
    background-position: top;
    border-radius: 0;
  }
`
const StyledBody = styled(Bodytext)`
  max-width: 580px;
  display: block;
  margin: 10px auto !important;
  letter-spacing: 0px;
  line-height: 22px;
  text-align: center;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    padding-bottom: 50px;
  }
`
const StyledHeading = styled(Heading)`
  font-size: 22px !important;
  font-weight: 600;
  line-height: 30px;
`

const BodyDiv = styled.div`
  margin: 0 auto;
  @media (max-width: ${style((theme) => theme.breakpoints.sm - 1)}px) {
    padding: 0 20px;
    align-self: center;
    margin: auto;
  }
`

const UpgradeSuccessPage: React.SFC<Props> = () => {
  const { height } = useWindowDimensions()
  const analytics = useAnalyticsClient()
  const isWebView = location?.pathname.includes('/wv/')
  const history = useHistory()

  useEffect(() => {
    analytics.track('Screen Viewed', UpgradeSubscriptionDone)
  }, [])

  const handleBackPress = () => {
    const url = isWebView ? '/wv/my-subscription' : '/settings/my-subscription'
    history.push(url, { referrer: location.pathname })
  }

  const handleDirectToPresent = () => {
    analytics.track('Button Tapped', UpgradeSubscriptionDoneCTA)
    isWebView
      ? window.location.assign('acorns://exit?navigate_to=present')
      : history.push('/present', { referrer: location.pathname })
  }

  return (
    <>
      {isWebView ? (
        <FullscreenTakeover innerHeight={height}>
          <WebViewActionStrip
            title={undefined}
            action={{
              onClick: handleBackPress,
              shouldShowCloseIcon: true,
            }}
          />
          <WVCard innerHeight={height}>
            <BodyDiv>
              <AcornsIcon
                icon={AcornsIcon.Icon.AcornsLogoWithBackground}
                width="104px"
              />
              <StyledHeading>Way to grow</StyledHeading>
              <StyledBody>
                You've successfully upgraded your subscription. Explore your new
                accounts and features on your home screen to help your money
                grow even faster.
              </StyledBody>
            </BodyDiv>
            <ButtonContainer>
              <StyledButton onPress={() => handleDirectToPresent}>
                See what's new
              </StyledButton>
            </ButtonContainer>
          </WVCard>
        </FullscreenTakeover>
      ) : (
        <>
          <ActionStrip
            maxWidth={800}
            actionText="Go back to Settings"
            title={undefined}
            onBack={() => handleBackPress}
            showBack={true}
          />
          <StyledCard innerHeight={height}>
            <BodyDiv>
              <AcornsIcon
                icon={AcornsIcon.Icon.AcornsLogoWithBackground}
                width="104px"
              />
              <StyledHeading>Way to grow</StyledHeading>
              <StyledBody>
                You've successfully upgraded your subscription. Explore your new
                accounts and features on your home screen to help your money
                grow even faster.
              </StyledBody>
              <StyledButton onPress={() => handleDirectToPresent}>
                See what's new
              </StyledButton>
            </BodyDiv>
          </StyledCard>
        </>
      )}
    </>
  )
}

export default UpgradeSuccessPage
